import {LitElement, html, css, svg} from 'lit';
import {customElement, property} from 'lit/decorators.js';

@customElement('obi-cursor-help-icon')
export class ObiCursorHelpIcon extends LitElement {
  @property({type: Boolean}) useCssColor = false;

  private icon = svg`<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
<path d="M13.5479 17.7849V17.5806C13.5518 16.8796 13.6132 16.3207 13.732 15.9041C13.8547 15.4875 14.0329 15.151 14.2665 14.8947C14.5001 14.6383 14.7812 14.4059 15.1099 14.1976C15.3554 14.0374 15.5751 13.8712 15.7691 13.6989C15.9631 13.5266 16.1175 13.3364 16.2324 13.1281C16.3472 12.9157 16.4046 12.6794 16.4046 12.419C16.4046 12.1426 16.3393 11.9003 16.2086 11.692C16.078 11.4836 15.9018 11.3234 15.68 11.2112C15.4623 11.0991 15.2207 11.043 14.9555 11.043C14.6981 11.043 14.4546 11.1011 14.2249 11.2173C13.9953 11.3294 13.8072 11.4977 13.6607 11.722C13.5142 11.9423 13.435 12.2167 13.4232 12.5452H11C11.0198 11.744 11.2098 11.0831 11.5702 10.5623C11.9305 10.0375 12.4076 9.64695 13.0015 9.39057C13.5954 9.13019 14.2507 9 14.9673 9C15.7553 9 16.4521 9.13219 17.0579 9.39658C17.6637 9.65696 18.1388 10.0355 18.4833 10.5322C18.8278 11.029 19 11.6279 19 12.3289C19 12.7976 18.9228 13.2142 18.7684 13.5787C18.6179 13.9393 18.4061 14.2597 18.1329 14.5401C17.8597 14.8165 17.537 15.0669 17.1648 15.2912C16.852 15.4795 16.5947 15.6758 16.3927 15.8801C16.1948 16.0844 16.0463 16.3207 15.9473 16.5891C15.8523 16.8575 15.8028 17.188 15.7988 17.5806V17.7849H13.5479Z" fill="currentColor"/>
<path d="M13.5479 18.7812H15.792V21H13.5479V18.7812Z" fill="currentColor"/>
<path d="M5 13L1 1L13 5L7 7L5 13Z" fill="currentColor"/>
</svg>
`;

  private iconCss = svg`<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M13.5479 17.7849V17.5806C13.5518 16.8796 13.6132 16.3207 13.732 15.9041C13.8547 15.4875 14.0329 15.151 14.2665 14.8947C14.5001 14.6383 14.7812 14.4059 15.1099 14.1976C15.3554 14.0374 15.5751 13.8712 15.7691 13.6989C15.9631 13.5266 16.1175 13.3364 16.2324 13.1281C16.3472 12.9157 16.4046 12.6794 16.4046 12.419C16.4046 12.1426 16.3393 11.9003 16.2086 11.692C16.078 11.4836 15.9018 11.3234 15.68 11.2112C15.4623 11.0991 15.2207 11.043 14.9555 11.043C14.6981 11.043 14.4546 11.1011 14.2249 11.2173C13.9953 11.3294 13.8072 11.4977 13.6607 11.722C13.5142 11.9423 13.435 12.2167 13.4232 12.5452H11C11.0198 11.744 11.2098 11.0831 11.5702 10.5623C11.9305 10.0375 12.4076 9.64695 13.0015 9.39057C13.5954 9.13019 14.2507 9 14.9673 9C15.7553 9 16.4521 9.13219 17.0579 9.39658C17.6637 9.65696 18.1388 10.0355 18.4833 10.5322C18.8278 11.029 19 11.6279 19 12.3289C19 12.7976 18.9228 13.2142 18.7684 13.5787C18.6179 13.9393 18.4061 14.2597 18.1329 14.5401C17.8597 14.8165 17.537 15.0669 17.1648 15.2912C16.852 15.4795 16.5947 15.6758 16.3927 15.8801C16.1948 16.0844 16.0463 16.3207 15.9473 16.5891C15.8523 16.8575 15.8028 17.188 15.7988 17.5806V17.7849H13.5479Z" style="fill: var(--element-active-color)"/>
<path d="M13.5479 18.7812H15.792V21H13.5479V18.7812Z" style="fill: var(--element-active-color)"/>
<path d="M5 13L1 1L13 5L7 7L5 13Z" style="fill: var(--element-active-color)"/>
</svg>
`;

  override render() {
    return html`
      <div class="wrapper">${this.useCssColor ? this.iconCss : this.icon}</div>
    `;
  }

  static override styles = css`
    .wrapper {
      height: 100%;
      width: 100%;
      line-height: 0;
    }
    .wrapper > * {
      height: 100%;
      width: 100%;
    }
  `;
}

declare global {
  interface HTMLElementTagNameMap {
    'obi-cursor-help-icon': ObiCursorHelpIcon;
  }
}
